<template>
    <div class="topic_body" id="scroll_top">
        <div v-show="!showTopicInfo">
            <div v-show="isShow">
                <ul class="topic_main">
                    <h3 align="center">单项选择题</h3>
                    <li class="knowledge" v-for="(item, index) in topicArr" :key="index">
                        <p class="question">{{ item.question }}</p>
                        <el-radio-group v-model="item.selectedAnswer">
                            <el-radio v-for="(option, optionIndex) in item.options" :key="optionIndex + '-' + index" :label="option.value">
                                {{ option.text }}
                            </el-radio>
                        </el-radio-group>
                    </li>
                </ul>
                <div class="btn" id="btn" @click="submit">提交答案</div>
            </div>
            <div class="result" v-show="!isShow">
                <h2 align="center">恭喜您，作答完毕</h2>
                <el-progress type="circle" :percentage="percent"></el-progress>
                <p class="tips-txt">正确率</p>
                <div class="answer-show-box">
                    <p>
                        正确答案是：
                        <span v-for="(item,index) in rightAnswerArr">{{ index + 1 }}.{{ item }}</span>
                    </p>
                    <p>
                        您的答案是：
                        <span v-for="(item,index) in selectedAnswerArr">{{ index + 1 }}.{{ item }}</span>
                    </p>
                </div>

                <div class="btn-box">
                    <div class="btn" @click="redo">重新做题</div>
                    <div class="btn" @click="checkTopic">查看详情</div>
                </div>
            </div>
        </div>
        <div v-show="showTopicInfo" class="check-info-box">
            <ul class="topic_main">
                <h3 align="center">单项选择题</h3>
                <li class="knowledge" v-for="(item, index) in topicArr" :key="index">
                    <p class="question">
                        <i v-show="item.rightAnswer == item.selectedAnswer" class="rightTopic icon el-icon-check"></i>
                        <i v-show="item.rightAnswer !== item.selectedAnswer" class="errorTopic icon el-icon-close"></i>
                        {{ item.question }}
                    </p>
                    <el-radio-group v-model="item.selectedAnswer">
                        <el-radio v-for="(option, optionIndex) in item.options" :class="item.rightAnswer == option.value ? 'rightTopic':''" :key="optionIndex + '-' + index" :label="option.value">
                            {{ option.text }}
                        </el-radio>
                    </el-radio-group>
                </li>
                <div class="mark"></div>
            </ul>
            <div class="btn" @click="redo">重新做题</div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery';
    export default {
        name: "Topic",
        data() {
            return {
                // drawerTopic: false,
                isShow: true,
                showTopicInfo:false,
                percent: '0',
                selectedAnswerArr: [], // 用户选中的答案
                rightAnswerArr: [], // 正确答案
                noAnswerArr: [], // 未作答的题目
                topicArr:[
                    {
                        question: '1．下列学习类型中，使用的训练数据集只有部分存在标签的是（    ）。',
                        options: [
                            { text: 'A．监督学习', value: 'A' },
                            { text: 'B．深度学习', value: 'B' },
                            { text: 'C．半监督学习', value: 'C' },
                            { text: 'D．无监督学习', value: 'D' }
                        ],
                        selectedAnswer: '',
                        rightAnswer: 'C',
                        rightTopicClass: false,
                    },
                    {
                        question: '2．给出一定数量的菊花和玫瑰花图像，以及它们对应的标签，设计出一个菊花和玫瑰花的分类器，这属于（    ）问题。',
                        options: [
                            { text: 'A．监督学习', value: 'A' },
                            { text: 'B．无监督学习', value: 'B' },
                            { text: 'C．半监督学习', value: 'C' },
                            { text: 'D．以上都可以', value: 'D' }
                        ],
                        selectedAnswer: '',
                        rightAnswer: 'A',
                        rightTopicClass: false,
                    },
                    {
                        question: '3．下列说法正确的是（    ）。',
                        options: [
                            { text: 'A．特征的个数越多，机器学习的效果越准确', value: 'A' },
                            { text: 'B．样本的数量越多，机器学习的效果越准确', value: 'B' },
                            { text: 'C．“过拟合”只有在监督学习中出现，在无监督学习中没有“过拟合”现象', value: 'C' },
                            { text: 'D．特征的个数应和样本的数量相匹配', value: 'D' }
                        ],
                        selectedAnswer: '',
                        rightAnswer: 'D',
                        rightTopicClass: false,
                    },
                    {
                        question: '4．Python机器学习常用库中，（    ）是实现机器学习的算法库。',
                        options: [
                            { text: 'A．NumPy', value: 'A' },
                            { text: 'B．Pandas', value: 'B' },
                            { text: 'C．Scikit-learn', value: 'C' },
                            { text: 'D．Matplotlib', value: 'D' }
                        ],
                        selectedAnswer: '',
                        rightAnswer: 'C',
                        rightTopicClass: false,
                    },
                    {
                        question: '5．使用Jupyter Notebook编辑器运行代码时，要求代码运行结果直接显示在单元格下方，并且在单元格下方又新建一个单元格，需要按（    ）快捷键。',
                        options: [
                            { text: 'A．Shift+Enter', value: 'A' },
                            { text: 'B．Ctrl+Enter', value: 'B' },
                            { text: 'C．Shift+Ctrl', value: 'C' },
                            { text: 'D．Alt+Ctrl', value: 'D' }
                        ],
                        selectedAnswer: '',
                        rightAnswer: 'A',
                        rightTopicClass: false,
                    },
                ]
            }
        },
        mounted: {

        },
        methods: {
            submit() {
                // 用户选择的正确答案
                 const userRightAnswerArr = this.topicArr.filter((item)=>{
                    return item.selectedAnswer === item.rightAnswer;
                });
                 console.log(userRightAnswerArr,'userRightAnswerArr');

                 // 用户正确率
                this.percent = userRightAnswerArr.length / this.topicArr.length * 100;

                // 正确答案
                this.rightAnswerArr = this.topicArr.map((item)=>{
                    return item.rightAnswer;
                });
                // 用户选择的答案
                this.selectedAnswerArr = this.topicArr.map((item)=>{
                    return item.selectedAnswer;
                });

                // 筛选出未作答的题
                this.noAnswerArr = this.topicArr.filter((item,index)=> {
                    if (item.selectedAnswer == "") {
                        return (index+1);
                    }
                });
                // 有未作答的题时，出现不能提交的提示内容。所有题目都作答后，方能提交答案
               if (this.noAnswerArr.length > 0) {
                   this.$message({
                       message: '还有'+this.noAnswerArr.length+"道题未作答，请作答完毕后再提交",
                       type: 'error',
                       duration: 2000,
                       customClass: 'myMessageTip' // 自定义类名
                   });
               } else {
                   this.isShow = !this.isShow;
                   this.scrollTop()
               }

            },
            redo() {
                this.isShow = !this.isShow;
                this.showTopicInfo = false;
                this.selectedAnswerArr = [];
                for (let i = 0; i < this.topicArr.length; i++) {
                    this.topicArr[i].selectedAnswer = '';
                }
             this.scrollTop();
            },
            checkTopic() {
                this.showTopicInfo = true;
                this.scrollTop()
            },
            scrollTop() {
                var box = document.getElementById('scroll_top');
                box.scrollTop = 0; // 设置scrollTop为0，滚动到最顶部
            }
        }
    }
</script>

<style scoped lang="scss">
    .topic_main {
        position: relative;
    }
    .mark {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 1;
        background: rgba(0, 0, 0, 0);
        width: 100%;
        height: 100%;
    }
    .topic_body {
        margin: 0;
        padding: 0 20px;
        text-align: center;
        font-family: "微软雅黑";
        background-color: #fff;
        color: #2F4058;
        height: 100%;
        overflow: auto;
        * {
            /deep/span {
                user-select: none !important;
            }
        }
    }

    * {
        margin: 0;
        padding: 0;
        list-style: none;
        user-select: none;
    }

    ul,
    div {
        margin: 0 auto;
    }

    h3 {
        padding: 30px 0 20px;
    }
    .topic_body .topic_main .question {
        background-color: #F2F2E7;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 16px;
        padding: 10px;
        text-indent: 0 !important;
    }

    .knowledge {
        border-bottom: 1px dotted;
        text-align: left;
        padding-bottom: 20px;
        font-size: 15px;
        line-height: 24px
    }

    .btn {
        border-radius: 4px;
        background-color: #D7A040;
        color: #fff;
        width: 200px;
        font-size: 16px;
        padding: 10px 0;
        margin: 40px auto;
    }
    .btn:hover {
        opacity: .8;
    }

    label {
        display: flex;
        align-items: center;
        margin: 0 20px 14px 30px;
        /deep/.el-radio__label{
            font-size: 15px;
            line-height: 1.3;
        }
    }
    /deep/.el-radio {
        white-space: normal;
    }
    .result {
        h2 {
            font-size: 24px;
            padding-top: 80px;
        }
        .btn-box {
            display: flex;
            justify-content: center;
            margin: 60px 0 30px;
            .btn {
                width: 200px;
                padding: 10px 0;
                margin: 0 10px;
                cursor: pointer;
            }
            .btn:first-child {
                background: #6c7f9a;
            }
        }
        .el-progress {
            margin-top: 30px;
            height: 200px;
            /deep/.el-progress-circle {
                width: 200px !important;
                path:last-child {
                    stroke: #00A8AC !important;
                }
            }
            /deep/.el-progress__text {
                font-size: 32px !important;
                color: #00A8AC !important;
                font-weight: bold;
            }
        }
        .tips-txt {
            font-size: 16px;
            margin-top: -90px;
            text-indent: 0 !important;
        }
        .answer-show-box {
            margin-top: 100px;
            p {
                font-size: 16px;
                width: 80%;
                margin: 10px auto;
                /*text-align: left;*/
                span {
                    margin-right: 18px;
                }
            }
        }
    }
    .check-info-box {
        .question {
            background: #f6f6f6;
        }
        .question i {
            font-weight: bold;
            font-size: 24px;
        }
        i.rightTopic {
            color: #13ce66;
        }
        .rightTopic /deep/.el-radio__label {
            background: #d3f6e2 !important;
            padding: 0 10px !important;
        }
        i.errorTopic {
            color: #f86413;
        }
    }
</style>
